








































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Validator, IRuleViolation } from '../Scripts/Validation';
import { SendService } from '../Scripts/SendService';
import { IProgram, ICourse, SearchType } from '../Scripts/ISearchService';
import { mapGetters } from 'vuex';
import { Getters } from '../store';

@Component({
	computed: { ...mapGetters({ administrationOrganization: Getters.administrationOrganization }) }
})
export default class EmailFavorites extends Vue {
	@Prop() public items!: IProgram[] | ICourse[];
	@Prop() public searchType!: SearchType;

	private wasValidated = false;
	private email = '';
	private note = '';
	private messages: IRuleViolation[] = [];
	private sent = false;

	get emailState (): boolean | null {
		if (!this.wasValidated) {
			return null;
		}

		return Validator.isEmail(this.email);
	}

	get noteState (): boolean | null {
		if (!this.wasValidated) {
			return null;
		}

		return this.note.length <= 255 ? null : false;
	}

	private resetModal (): void {
		this.wasValidated = false;
		this.email = '';
		this.note = '';
		this.messages = [];
	}

	private async send (): Promise<boolean> {
		this.messages = [];

		this.wasValidated = true;

		const valid = this.emailState && this.noteState !== false;

		if (!valid) {
			return false;
		}

		this.$emit('busy', true);

		const ids: string[] = (this.items as { id: string }[]).map((p) => p.id);

		const sender = new SendService();

		try {
			const response = await sender.sendFavorites({
				searchType: this.searchType,
				ids,
				emailAddress: this.email,
				note: this.note,
				query: ''
			});
			if (response.status === 200) {
				this.sent = true;
				this.done();
				return true;
			} else {
				this.messages = response.failureMessages;
				return false;
			}
		} catch (error) {
			const message = 'Temporarily unable to connect to the server. It is safe to try again.';
			this.messages = [{ message } as IRuleViolation];
			return false;
		} finally {
			this.$emit('busy', false);
		}
	}

	private done (): void {
		this.$emit('success');
	}
}

